















import { Component, Mixins } from "vue-property-decorator";
import MeetingForm from "./MeetingForm.vue";
import {Meeting} from "@api/models/meetings/Meeting";
import {DateObjectUnits, DateTime} from "luxon";
import {RepositoryFabric} from "@api/repositories/RepositoryFabric";
import {UserRepository} from "@api/repositories/UserRepository";
import {roundTo} from "@common/roundTo";
import { hash } from "@common/stringHash";
import {dateInOriginalOffset} from "@common/dateTimeHelper";
import {incrementBasedOnRange} from '@common/dateTimeHelper';
import {isSameDate} from "@common/dateTimeHelper";
import {PROFILE_FIELDS_BASIC, UserProfile} from "@api/models/UserProfile";
import {IsFromMy} from "@mixins/isFromMy";
import AnalyticsMixin from "@mixins/AnalyticsMixin";

@Component({
    name: 'CreateMeeting',
    components: { MeetingForm }
})
export default class CreateMeeting extends Mixins(AnalyticsMixin, IsFromMy) {
  meeting: Meeting|null = null;
  isMounted = false;
  hashedQueryParams: any = null;
  originalDate: DateTime|null = null;

  get userId() {
     return this.$store.state.session.userId;
  }

  get lang() {
      return this.$store.state.session?.language || navigator.language.split('-')[0] || "ru";
  }

  get timeRange() {
     return this.$store.getters['timeRange'];
  }

  roundTo15(value: number) {
     return roundTo(value, 15);
  }

  activated() {
     const currentQueryParamsHash = hash(JSON.stringify(this.$route.query));
     if (this.isMounted && (this.meeting == null || currentQueryParamsHash != this.hashedQueryParams)) {
        this.prepareNewMeeting();
        this.setIsFromMy();
     }
     this.hashedQueryParams = currentQueryParamsHash;

     this.sendScreenView('Meeting creating');
  }

  async mounted() {
     await this.prepareNewMeeting();
     this.isMounted = true;
     this.setIsFromMy();
  }

  async prepareNewMeeting() {
     const time: string = (this.$route.query.time as string) || '',
           date: string = (this.$route.query.date as string) || '';
     let beginAt = DateTime.local();
     if (date) {
        const newDate: DateTime = DateTime.fromISO(date);
        if (newDate.isValid) {
           beginAt = newDate;
        }
     }
     if (time) {
        const parts = time.split(':'),
                units: DateObjectUnits = {};
        if (parts[0]) {
           units.hour = parseInt(parts[0]);
        }
        if (parts[1]) {
           units.minute = parseInt(parts[1]);
        }
        if (Object.keys(units).length) {
           beginAt = beginAt.set(units);
        }
     }
     else {
        const now = DateTime.local();
        if (isSameDate(beginAt, now)) {
           beginAt = beginAt.set({
              hour: now.hour,
              minute: now.minute
           })
        }
        else {
           beginAt = beginAt.set({
              hour: this.timeRange.begin >= 0 ? this.timeRange.begin : 24 + this.timeRange.begin,
              minute: 0
           })
        }
     }
     beginAt = beginAt.set({minute: this.roundTo15(beginAt.minute)});

     const increment = incrementBasedOnRange(beginAt.toFormat('HH:mm'), this.timeRange);
     beginAt = beginAt.plus({
        days: increment
     })
     this.originalDate = dateInOriginalOffset(beginAt, this.$store.state.timeZoneOffset || 0 );
     const endAt = beginAt.plus({minutes: 15});

     let participants: UserProfile[] = [];

     const userIds = [this.userId];

     if (this.$route.query.userId) {
        userIds.push(parseInt(this.$route.query.userId as string));
     }

     try {
        participants = await (this.$repositories.get(RepositoryFabric.USER) as UserRepository).profiles({
           take: -1,
           skip: 0,
           where: {
             userId: { $in: userIds }
           },
           include: PROFILE_FIELDS_BASIC
        });
     }
     catch (e) {
        this.$store.dispatch('reportException', e);
     }

     this.$set(this, 'meeting', new Meeting({
        id: '',
        ownerId: this.userId,
        eventId: this.$store.state.events.selected,
        beginAt: beginAt,
        endAt: endAt,
        participants: participants
     }));
  }

  beforeSave() {
     this.$store.dispatch('showSpinner');
  }

  saved(meeting: Meeting) {
     this.$store.dispatch('program/setSavedMeeting', meeting);
     this.$store.dispatch('hideSpinner');
     this.$store.dispatch('routing/removeByRoute', 'EditMeeting');//remove from routing module

     setTimeout(() => {
        this.meeting = null;
     }, 300);

     this.$emit('back')
  }

  saveError(e: any) {
     this.$store.dispatch('reportException', e);
     this.$store.dispatch('hideSpinner');
  }

  closed() {
     const routingFromName: string = this.$store.getters['routing/getBackLink']('CreateMeeting', 'Invites');
     this.$store.dispatch('routing/removeByRoute', 'CreateMeeting');//remove from routing module
     this.$router.push({
        name: routingFromName,
        params: {
           backend: this.$route.params.backend,
           resetScrolls: 'true'
        },
        query: this.getHomeQueryParams()
     });
     setTimeout(() => {
        this.meeting = null;
     }, 300)
  }
}
